import React, { useRef, useState } from 'react';
import _noop from 'lodash/noop';

import useToggle from '@lyearn/core/hooks/useToggle';
import { useTranslation } from '@lyearn/i18n';
import { cn } from '@lyearn/style';
import { Stack } from '@lyearn/ui';
import DiscardChangesDialog from '@/components/DiscardChangesDialog';
import Loader from '@/components/Loader';
import { Dialog } from '@/components/Modals';
import AddTaskButton from '@/modules/goals/modules/okr/views/OKRDetails/components/AddTaskButton';
import { RelatedEntityTypeEnum } from '@/types/schema';

import AddOrEditTaskDialog, { AddOrEditTaskDialogRefType } from './AddOrEditTaskDialog';
import { dialogFooterStyles, dialogStyles, loaderStyles } from './styles';
import { AddOrEditTaskDialogContainerProps } from './types';

const dialogClasses = {
  paper: dialogStyles,
};

const AddOrEditTaskDialogContainer: React.FC<AddOrEditTaskDialogContainerProps> = (props) => {
  const { isFetching, isSubmitting, task, entity, entityId, fileId: fileIdProp, onClose } = props;
  const { t } = useTranslation();
  const [showDiscardChangesDialog, { toggle: toggleDiscardChangesDialog }] = useToggle();
  const addOrEditTaskDialogRef = useRef<AddOrEditTaskDialogRefType>({ onSubmit: _noop, onClose });
  const [fileId, setFileId] = useState<string | null | undefined>(task ? task?.fileId : fileIdProp);

  return (
    <>
      <Dialog
        action={
          isFetching
            ? undefined
            : {
                text: t('Common:Actions.Save'),
                discardText: t('Common:Actions.Cancel'),
                onSubmit: () => {
                  addOrEditTaskDialogRef.current.onSubmit();
                },
                disabled: isSubmitting || isFetching,
                className: dialogFooterStyles,
                isSubmitting: isSubmitting,
                TertiaryAction:
                  task?.parentId || entity === RelatedEntityTypeEnum.Meeting ? undefined : (
                    <Stack>
                      <AddTaskButton
                        entity={entity}
                        entityId={entityId}
                        fileId={fileId}
                        onClose={onClose}
                      />
                    </Stack>
                  ),
              }
        }
        classes={dialogClasses}
        onClose={() => {
          addOrEditTaskDialogRef.current.onClose();
        }}>
        {isFetching ? (
          <Loader className={cn(loaderStyles, 'mx-auto')} />
        ) : (
          <AddOrEditTaskDialog
            {...props}
            ref={addOrEditTaskDialogRef}
            setFileId={setFileId}
            toggleDiscardChangesDialog={toggleDiscardChangesDialog}
          />
        )}
      </Dialog>
      {showDiscardChangesDialog ? (
        <DiscardChangesDialog
          header={{
            description: t('Task:DiscardDescription'),
          }}
          onClose={toggleDiscardChangesDialog}
          onDiscard={onClose}
        />
      ) : null}
    </>
  );
};

export default AddOrEditTaskDialogContainer;
